import React, { useEffect, useState, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { Link, useHistory, withRouter } from "react-router-dom";
import { isEmpty } from "lodash";
import * as moment from "moment";
import {
  ButtonDropdown,
  InputGroup,
  InputGroupText,
  Toast,
  ToastBody,
  Tooltip,
  UncontrolledTooltip,
} from "reactstrap";
import axios from "axios";
// Import Images
import dummyImg from "../../../assets/images/users/user-dummy-img.jpg";

import {
  Col,
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  ModalFooter,
  Table,
  FormFeedback,
  Button,
} from "reactstrap";
import Select from "react-select";

import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

//Import actions
import {
  getChauffeurs as onGetChauffeurs,
  addNewChauffeur as onAddNewChauffeur,
  updateChauffeur as onUpdateChauffeur,
} from "../../../store/actions";
//redux
import { useSelector, useDispatch } from "react-redux";
import TableContainer from "../../../Components/Common/TableContainer";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import Loader from "../../../Components/Common/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useReducer } from "react";
import { withTranslation } from "react-i18next";
import axiosInstance from "../../../axiosConfig";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ChauffeurEnAttente = (props) => {
  const [photo, setphoto] = useState(null);
  const [piece_identite, setpiece_identite] = useState(null);
  const [photo_engin, setphoto_engin] = useState(null);
  const [attestation_residence, setattestation_residence] = useState(null);
  const [visite_technique, setvisite_technique] = useState(null);
  const [assurance, setassurance] = useState(null);
  const [permis, setpermis] = useState(null);
  const [droit_taxi, setdroit_taxi] = useState(null);

  const [showDatePicker, setShowDatePicker] = useState(false);

  const history = useHistory();
  const [formData1, setFormData1] = useState({});

  const token = JSON.parse(localStorage.getItem("authUser"))
    ? JSON.parse(localStorage.getItem("authUser")).accessToken
    : null;

  const [loading, setLoading] = useState(true);

  const fetchDataDetail = async () => {
    try {
      const driverList = await axiosInstance.get(`/driverlist/`);
    //   console.log("driverList: ", driverList);
      if (driverList?.data) {
        const driverAttente = driverList.data.data.filter(
          (chauffeur) => chauffeur.etat === "En attente"
        );
        setChauffeurs(driverAttente);
      }
    } catch (err) {
    //   console.log(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchDataDetail();
  }, []);

  const [isEdit, setIsEdit] = useState(false);
  const [isEditPhone, setIsEditPhone] = useState(false);
  const [driverSelected, setDriverSelected] = useState(null);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [chauffeurs, setChauffeurs] = useState([]);
  const [chauffeur, setChauffeur] = useState([]);

  //delete Conatct
  const [deleteModal, setDeleteModal] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalMotif, setModalMotif] = useState(false);

  const handleClickViewMotif = (etat, motifs) => {
    if (etat === "Desactiver" && motifs != null) {
      alert(motifs);
    }
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setChauffeur(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const onClickDelete = (chauffeur) => {
    setChauffeur(chauffeur);
    setDeleteModal(true);
  };

  // Add Data
  const handleChauffeurClicks = () => {
    setChauffeur("");
    setIsEdit(false);
    setIsEditPhone(false);
    toggle();
  };

  const dateFormat = () => {
    var d = new Date(),
      months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
    return d.getDate() + " " + months[d.getMonth()] + ", " + d.getFullYear();
  };

  const timeFormat = () => {
    let d = new Date();
    let minutes =
      d.getMinutes().toString().length === 1
        ? "0" + d.getMinutes()
        : d.getMinutes();
    let hours = d.getHours().toString() % 12 || 12;
    hours = hours <= 9 ? (hours = "0" + hours) : hours;
    let ampm = d.getHours() >= 12 ? "PM" : "AM";
    return hours + ":" + minutes + ampm;
  };

  const [imgPieceId, setImgPieceId] = useState(null);
  const [imgAttestationResidence, setImgAttestationResidence] = useState(null);
  const [imgPermis, setImgPermis] = useState(null);
  const [imgPhoto, setImgPhoto] = useState(null);
  const [imgAssurance, setImgAssurance] = useState(null);
  const [imgVisite, setImgVisite] = useState(null);
  const [imgEngin, setImgEngin] = useState(null);
  const [imgDroitTaxi, setImgDroitTaxi] = useState(null);
  const [imgCarteGrise, setImgCarteGrise] = useState(null);

  const [file1, setFile1] = useState();
  const [file2, setFile2] = useState();
  const [file3, setFile3] = useState();
  const [file4, setFile4] = useState();
  const [file5, setFile5] = useState();
  const [file6, setFile6] = useState();
  const [file7, setFile7] = useState();
  const [file8, setFile8] = useState();
  const [file9, setFile9] = useState();

  function handlePiece(e) {
    setFile1(URL.createObjectURL(e.target.files[0]));
    setImgPieceId(e.target.files[0]);
  }

  function handleAttestation(e) {
    setFile2(URL.createObjectURL(e.target.files[0]));
    setImgAttestationResidence(e.target.files[0]);
  }

  function handleCarteGrise(e) {
    setFile9(URL.createObjectURL(e.target.files[0]));
    setImgCarteGrise(e.target.files[0]);
  }

  function handlePermis(e) {
    setFile3(URL.createObjectURL(e.target.files[0]));
    setImgPermis(e.target.files[0]);
  }

  function handlePhoto(e) {
    setFile4(URL.createObjectURL(e.target.files[0]));
    setImgPhoto(e.target.files[0]);
  }

  function handleAssurance(e) {
    setFile5(URL.createObjectURL(e.target.files[0]));
    setImgAssurance(e.target.files[0]);
  }

  function handleVisite(e) {
    setFile6(URL.createObjectURL(e.target.files[0]));
    setImgVisite(e.target.files[0]);
  }

  function handleEngin(e) {
    setFile7(URL.createObjectURL(e.target.files[0]));
    setImgEngin(e.target.files[0]);
  }

  function handleDroitTaxi(e) {
    setFile8(URL.createObjectURL(e.target.files[0]));
    setImgDroitTaxi(e.target.files[0]);
  }

  const [date_expir_identite, setdate_expir_identite] = useState(new Date());
  const [date_expir_permis, setdate_expir_permis] = useState(new Date());
  const [date_expir_assurance, setdate_expir_assurance] = useState(new Date());
  const [date_expir_droit_taxi, setdate_expir_droit_taxi] = useState(
    new Date()
  );

  // Update Data
  const handleChauffeurClick = useCallback(
    (arg) => {
      const chauffeur = arg;

      setChauffeur({
        id: chauffeur.id,
        user_id: chauffeur.user_id,
        first_name: chauffeur.first_name,
        last_name: chauffeur.last_name,
        email: chauffeur.email,
        telephone: chauffeur.telephone,
        password: chauffeur.password,
        independant: chauffeur.independant,
        type_conducteur: chauffeur.type_conducteur,
        statut: chauffeur.statut,
        etat: chauffeur.etat,
        code_parrain: chauffeur.code_parrain,
        // piece_identite: chauffeur.piece_identite,
        // attestation_residence: chauffeur.attestation_residence,
        // permis: chauffeur.permis,
        // photo: chauffeur.photo,
        marque: chauffeur.marque,
        modele: chauffeur.modele,
        immatriculation: chauffeur.immatriculation,
        type_engin: chauffeur.type_engin,
        climatisation: chauffeur.climatisation,
        chassie: chauffeur.chassie,
        nbr_place: chauffeur.nbr_place,
        // assurance: chauffeur.assurance,
        // visite_technique: chauffeur.visite_technique,
        // photo_engin: chauffeur.photo_engin
      });

      toggle();
    },
    [toggle]
  );

  // Column
  const columns = useMemo(
    () => [
      // {
      //   Header: <input type="checkbox" id="checkBoxAll" onClick={ () => checkedAll() } />,
      //   Cell: ( cellProps ) =>
      //   {
      //     return <input type="checkbox" name="id" className="chauffeurCheckBox" value={ cellProps.row.original.id } />;
      //   },
      //   id: '#',
      // },
      {
        Header: props.t("Last Name"),
        accessor: "last_name",
        filterable: false,
      },
      {
        Header: props.t("First Name"),
        accessor: "first_name",
        filterable: false,
      },
      {
        Header: props.t("Email"),
        accessor: "email",
        filterable: false,
      },
      {
        Header: props.t("Téléphone"),
        accessor: "telephone",
        filterable: false,
        Cell: (telephone) => (
          <>
            {telephone.row.original.telephone}
            {/* <Link
              to="#"
              className="text-warning d-inline-block"
              onClick={() => {
                const chauffeurData = telephone.row.original;
                handleChauffeurClick(chauffeurData);
                toggle();
                setIsEditPhone(true);
                setIsEdit(false);
              }}
            >
              <i className="ri-pencil-fill align-top"></i>
            </Link> */}
          </>
        ),
      },
      {
        Header: props.t("Chauffeur"),
        accessor: "independant",
        filterable: false,
        Cell: (chauffeur) => (
          <span
            className={
              chauffeur.row.original.independant === 1
                ? "badge badge-soft-success me-1"
                : "badge badge-soft-danger me-1"
            }
          >
            {chauffeur.row.original.independant === 1
              ? "Indépendant"
              : "Maison"}
          </span>
        ),
      },
      {
        Header: props.t("Etat"),
        accessor: "etat",
        filterable: false,
        Cell: (chauffeur) => (
          <span
            className={
              chauffeur.row.original.etat === "Activer"
                ? "badge badge-soft-success me-1"
                : chauffeur.row.original.etat === "Desactiver"
                ? "badge badge-soft-danger me-1"
                : "badge badge-soft-warning me-1"
            }
            role="button"
            onClick={() =>
              handleClickViewMotif(
                chauffeur.row.original.etat,
                chauffeur.row.original.motifs
              )
            }
          >
            {chauffeur.row.original.etat}
          </span>
        ),
      },
      {
        Header: props.t("Statut"),
        accessor: "statut",
        filterable: true,
        Cell: (chauffeur) => (
          <>
            {chauffeur.row.original.statut === "Online" ? (
              <span className="badge badge-soft-success me-1">En ligne</span>
            ) : (
              <span className="badge badge-soft-danger me-1">Hors ligne</span>
            )}
          </>
        ),
      },
      {
        Header: props.t("Action"),
        Cell: (cellProps) => {
          const chauffeurData = cellProps.row.original;
          const chauffeurDataId = cellProps.row.original.id;
          const [info, setInfo] = useState([]);
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item" title={props.t("Voir")}>
                <Link
                  to={`/chauffeur/${chauffeurData.user_id}`}
                  className="text-success d-inline-block"
                  onClick={() => {
                    const chauffeurData = cellProps.row.original;
                  }}
                >
                  <i className="ri-eye-fill align-bottom"></i>
                </Link>
              </li>
              {/* <li className="list-inline-item" title={props.t("Modifier")}>
                <Link
                  to="#"
                  className="btn btn-sm btn-warning d-inline-block"
                  onClick={() => {
                    const chauffeurData = cellProps.row.original;
                    handleChauffeurClick(chauffeurData);
                    setIsEdit(true);
                    setIsEditPhone(false);
                    toggle();
                  }}
                >
                  <i className="ri-pencil-fill align-bottom"></i>
                </Link>
              </li> */}
              {chauffeurData.etat === "En attente" ? (
                <>
                  <li className="list-inline-item" title={props.t("Activer")}>
                    <Link
                      to="#"
                      className="btn btn-sm btn-outline-success d-inline-block"
                      onClick={(e) => {
                        e.preventDefault();
                        const chauffeurDataId = cellProps.row.original.id;
                        handleaccept(chauffeurDataId);
                      }}
                    >
                      <i className="ri-check-line align-bottom"></i>
                    </Link>
                  </li>
                  <li
                    className="list-inline-item"
                    title={props.t("Désactiver")}
                  >
                    <Link
                      to="#"
                      className="btn btn-sm btn-outline-danger d-inline-block"
                      onClick={(e) => {
                        e.preventDefault();
                        const chauffeurDataId = cellProps.row.original.id;
                        setDriverSelected(chauffeurDataId);
                        setModalMotif(true);
                      }}
                    >
                      <i className="ri-close-line align-bottom"></i>
                    </Link>
                  </li>
                </>
              ) : chauffeurData.etat === "Activer" ? (
                <>
                  <li
                    className="list-inline-item"
                    title={props.t("En attente")}
                  >
                    <Link
                      to="#"
                      className="btn btn-sm btn-warning d-inline-block"
                      onClick={(e) => {
                        e.preventDefault();
                        const chauffeurDataId = cellProps.row.original.id;
                        handleattente(chauffeurDataId);
                      }}
                    >
                      <i className="ri-subtract-line align-bottom"></i>
                    </Link>
                  </li>

                  <li
                    className="list-inline-item"
                    title={props.t("Désactiver")}
                  >
                    <Link
                      to="#"
                      className="btn btn-sm btn-danger d-inline-block"
                      onClick={(e) => {
                        e.preventDefault();
                        const chauffeurDataId = cellProps.row.original.id;
                        setDriverSelected(chauffeurDataId);
                        setModalMotif(true);
                      }}
                    >
                      <i className="ri-close-line align-bottom"></i>
                    </Link>
                  </li>
                </>
              ) : (
                <>
                  <li
                    className="list-inline-item"
                    title={props.t("En attente")}
                  >
                    <Link
                      to="#"
                      className="btn btn-sm btn-warning d-inline-block"
                      onClick={(e) => {
                        e.preventDefault();
                        const chauffeurDataId = cellProps.row.original.id;
                        handleattente(chauffeurDataId);
                      }}
                    >
                      <i className="ri-subtract-line align-bottom"></i>
                    </Link>
                  </li>
                  <li className="list-inline-item" title={props.t("Activer")}>
                    <Link
                      to="#"
                      className="btn btn-sm btn-success d-inline-block"
                      onClick={(e) => {
                        e.preventDefault();
                        const chauffeurDataId = cellProps.row.original.id;
                        handleaccept(chauffeurDataId);
                      }}
                    >
                      <i className="ri-check-line align-bottom"></i>
                    </Link>
                  </li>
                </>
              )}
            </ul>
          );
        },
      },
    ],
    [handleChauffeurClick, props]
    // [setInfo, handleChauffeurClick, toggle, props, handlerefuse, handleaccept]
  );

  const SUPPORTED_FORMATS = ["image/*"];
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      first_name: (chauffeur && chauffeur.first_name) || "",
      last_name: (chauffeur && chauffeur.last_name) || "",
      ville: (chauffeur && chauffeur.ville) || "",
      email: (chauffeur && chauffeur.email) || "",
      telephone: (chauffeur && chauffeur.telephone) || "",
      type_conducteur: (chauffeur && chauffeur.type_conducteur) || "Conducteur",
      code_parrain: (chauffeur && chauffeur.code_parrain) || "",
      password: (chauffeur && chauffeur.password) || "",

      photo: null,
      photo_engin: null,
      attestation_residence: null,
      visite_technique: null,

      piece_identite: null,
      permis: null,
      carte_grise: null,
      assurance: null,
      droit_taxi: null,
    },
    validationSchema: Yup.object({
      first_name:
        !isEditPhone &&
        Yup.string().required(props.t("Veuillez renseigner les prénoms")),
      last_name:
        !isEditPhone &&
        Yup.string().required(props.t("Veuillez renseigner le nom")),
      email:
        !isEditPhone &&
        Yup.string().required(props.t("Veuillez renseigner l'email")),
      telephone:
        (!isEdit || isEditPhone) &&
        Yup.string().required(
          props.t("Veuillez renseigner le numero de téléphone")
        ),

      ville:
        !isEdit &&
        !isEditPhone &&
        Yup.string().required(props.t("Veuillez renseigner la ville")),
      type_conducteur:
        !isEdit &&
        !isEditPhone &&
        Yup.string().required(
          props.t("Veuillez renseigner le type de conducteur")
        ),
      password:
        !isEdit &&
        !isEditPhone &&
        Yup.string().required(props.t("Veuillez renseigner le mot de passe")),

      // Fichiers
      photo:
        !isEdit &&
        !isEditPhone &&
        Yup.mixed().required(props.t("Veuillez télécharger une photo")),
      photo_engin:
        !isEdit &&
        !isEditPhone &&
        Yup.mixed().required(
          props.t("Veuillez télécharger la photo de l'engin")
        ),
      visite_technique:
        !isEdit &&
        !isEditPhone &&
        Yup.mixed().required(
          props.t("Veuillez télécharger la visite technique")
        ),

      attestation_residence:
        !isEdit &&
        !isEditPhone &&
        Yup.mixed().required(
          props.t("Veuillez télécharger l'attestation de résidence")
        ),

      piece_identite:
        !isEdit &&
        !isEditPhone &&
        Yup.mixed().required(
          props.t("Veuillez télécharger la pièce d'identité")
        ),
      permis:
        !isEdit &&
        !isEditPhone &&
        Yup.mixed().required(
          props.t("Veuillez télécharger le permis de conduire")
        ),
      carte_grise:
        !isEdit &&
        !isEditPhone &&
        Yup.mixed().required(props.t("Veuillez télécharger la carte grise")),
      assurance:
        !isEdit &&
        !isEditPhone &&
        Yup.mixed().required(props.t("Veuillez télécharger l'assurance")),
      droit_taxi:
        !isEdit &&
        !isEditPhone &&
        Yup.mixed().required(props.t("Veuillez télécharger le droit taxi")),
    }),
    onSubmit: (values) => {
      // console.log("Edit: ", isEdit);
      // console.log("isEditPhone: ", isEditPhone);

      if (isEdit) {
        const updateChauffeur = {
          first_name: values.first_name,
          last_name: values.last_name,
          email: values.email,
        };

      //   console.log("updateChauffeur:", updateChauffeur);
        try {
          const data = axiosInstance
            .put(`/driverinfoupdate/?id=${chauffeur.user_id}/`, updateChauffeur)
            .then((response) => {
              // dispatch(onUpdateChauffeur(updateChauffeur));
              validation.resetForm();
              toast.success(props.t("Chauffeur modifié avec succès"), {
                autoClose: 3000,
              });
              fetchDataDetail();
            })
            .catch((error) => {
              toast.error(props.t("Echec de la modification du Chauffeur"), {
                autoClose: 3000,
              });
            });

          // window.location.reload(true);
        } catch (err) {
        //   console.log(err);
          toast.error(props.t("Echec de la modification du Chauffeur"), {
            autoClose: 2000,
          });
        }
        fetchDataDetail();
        setIsEdit(false);
      } else if (isEditPhone) {
        const updatePhoneChauffeur = {
          newTelephone: values.telephone,
        };

      //   console.log("updatePhoneChauffeur:", updatePhoneChauffeur);
        try {
          const data = axiosInstance
            .put(
              `/driverchangephone/?id=${chauffeur.user_id}/`,
              updatePhoneChauffeur
            )
            .then((response) => {
              // dispatch(onUpdateChauffeur(updateChauffeur));
              validation.resetForm();
              toast.success(
                props.t("Numero de téléphone du chauffeur modifié avec succès"),
                { autoClose: 3000 }
              );
              fetchDataDetail();
            })
            .catch((error) => {
              toast.error(
                props.t(
                  "Echec de la modification du numero de téléphone du Chauffeur"
                ),
                { autoClose: 3000 }
              );
            });

          fetchDataDetail();
          setIsEditPhone(false);
          // window.location.reload(true);
        } catch (err) {
        //   console.log(err);
          toast.error(props.t("Echec de la modification du Chauffeur"), {
            autoClose: 2000,
          });
        }
        fetchDataDetail();
      } else {
        const registerData = new FormData();
        registerData.append("first_name", values.first_name);
        registerData.append("last_name", values.last_name);
        registerData.append("ville", values.ville);
        registerData.append("email", values.email);
        registerData.append("telephone", values.telephone);
        registerData.append("type_conducteur", values.type_conducteur);
        registerData.append("cg", true);
        registerData.append("code_parrain", values.code_parrain);
        registerData.append("independant", false);
        registerData.append("password", values.password);
        registerData.append("piece_identite", values.piece_identite);
        registerData.append(
          "attestation_residence",
          values.attestation_residence
        );
        registerData.append("carte_grise", values.carte_grise);
        registerData.append("permis", values.permis);
        registerData.append("photo", values.photo);
        registerData.append("assurance", values.assurance);
        registerData.append("visite_technique", values.visite_technique);
        registerData.append("photo_engin", values.photo_engin);
        registerData.append("droit_taxi", values.droit_taxi);

        registerData.append("date_expir_identite", date_expir_identite);
        registerData.append("date_expir_permis", date_expir_permis);
        registerData.append("date_expir_assurance", date_expir_assurance);
        registerData.append("date_expir_droit_taxi", date_expir_droit_taxi);

        // !!!!

      //   console.log("first_name", values.first_name);
      //   console.log("last_name", values.last_name);
      //   console.log("ville", values.ville);
      //   console.log("email", values.email);
      //   console.log("telephone", values.telephone);
      //   console.log("type_conducteur", values.type_conducteur);
      //   console.log("cg", true);
      //   console.log("code_parrain", values.code_parrain);
      //   console.log("independant", false);
      //   console.log("password", values.password);
      //   console.log("piece_identite", values.piece_identite);
      //   console.log("attestation_residence", values.attestation_residence);
      //   console.log("permis", values.permis);
      //   console.log("photo", values.photo);
      //   console.log("assurance", values.assurance);
      //   console.log("visite_technique", values.visite_technique);
      //   console.log("photo_engin", values.photo_engin);
      //   console.log("droit_taxi", values.droit_taxi);
      //   console.log("date_expir_identite", date_expir_identite);
      //   console.log("date_expir_permis", date_expir_permis);
      //   console.log("date_expir_assurance", date_expir_assurance);
      //   console.log("date_expir_droit_taxi", date_expir_droit_taxi);

        // const registerData = {
        //   first_name: values.first_name,
        //   last_name: values.last_name,
        //   email: values.email,
        //   telephone: values.telephone,
        //   type_conducteur: values.type_conducteur,
        //   cg: values.cg,
        //   code_parrainage: values.code_parrain,
        //   independant: false,
        //   password: values.password,
        // };

        // const piece_identite = piece_identiteName;
        // const attestation_residence = attestation_residenceName;
        // const permis = permisName;
        // const photo = photoName;
        // const droit_taxi = droit_taxiName;

        // const date_expir_identite = req.body.date_expir_identite;
        // const date_expir_permis = req.body.date_expir_permis;

        // route: /admindriverregister/;
        // console.log("registerData: ", registerData);

        // save new Chauffeur
        // console.log("registerData", registerData.getAll());
      //   console.log("registerData entries:", registerData);
        try {
          const data = axiosInstance
            .post(`/admindriverregister/`, registerData)
            .then((response) =>
              // const data = axiosInstance
              //   .post(`/driverregister/`, registerData)
              //   .then((response) =>
              {
              //   console.log("Reponse sauvegarder avec success: ", response);

                history.push("/chauffeur");

                validation.resetForm();
                setdate_expir_identite(new Date());
                setdate_expir_permis(new Date());
                setdate_expir_assurance(new Date());
                setdate_expir_droit_taxi(new Date());

                toast.success(props.t("Chauffeur ajouté avec succès"), {
                  autoClose: 3000,
                });
                // fetch
              }
            );

        //   console.log("data: ", data);
        } catch (err) {
          toast.error(props.t("Echec de l'ajout de la Chauffeur"), {
            autoClose: 3000,
          });
          console.error(err);
        }

        fetchDataDetail();
      }
      toggle();

      setFile1(null);
      setFile2(null);
      setFile3(null);
      setFile4(null);
      setFile5(null);
      setFile6(null);
      setFile7(null);
      setFile8(null);
    },
  });

  const validationRefuse = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      motif_refuse: "Pas de motif !",
    },
    validationSchema: Yup.object({
      motif_refuse: Yup.string().required(props.t("Veuillez entrer un motif")),
    }),
    onSubmit: (values) => {
    //   console.log("Motif de la désactivation: ", values.motif_refuse);
    //   console.log("Compte désactivé: ", driverSelected);

      handlerefuse(driverSelected, values.motif_refuse);

      setModalMotif(false);
      setDriverSelected(null);
    },
  });

  const handleattente = (idChauffeur) => {
    axios
      .put(`https://stepnode.inawo.pro/driveretat/?id=${idChauffeur}`, {
        etat: "En attente",
        motif: null,
      })
      .then((res) => {
        // console.log(res);
        toast.success("Chauffeur mis en attente avec succès");
        fetchDataDetail();
      })
      .catch((err) => {
      //   console.log(err);
        toast.error("Erreur lors de la mise en attente du chauffeur");
      });
  };

  const handleaccept = (idChauffeur) => {
    // axios.put( `https://stepnode.inawo.pro/driveretat/?id=${ e }`, {
    axiosInstance
      .put(`/driveretat/?id=${idChauffeur}`, {
        etat: "Activer",
        motif: null,
      })
      .then((res) => {
      //   console.log(res);
        toast.success("Chauffeur activé avec succès");
        fetchDataDetail();
      })
      .catch((err) => {
      //   console.log(err);
        toast.error("Erreur lors de l'activation du chauffeur");
      });
  };

  const handlerefuse = (idChauffeur, motif) => {
    // axios.put( `https://stepnode.inawo.pro/driveretat/?id=${ e }`, {
    axiosInstance
      .put(`/driveretat/?id=${idChauffeur}`, {
        etat: "Desactiver",
        motif: motif,
      })
      .then((res) => {
      //   console.log(res);
        toast.success("Chauffeur désactivé avec succès");
        fetchDataDetail();
      })
      .catch((err) => {
      //   console.log(err);
        toast.error("Erreur lors de la désactivation du chauffeur");
      });
  };

  // // Node API
  // useEffect(() => {
  //   if (isChauffeurCreated) {
  //     setChauffeur(null);
  //     fetchDataDetail();
  //   }
  // }, [
  //   dispatch,
  //   isChauffeurCreated,
  // ]);

  const handleValidDate = (date) => {
    const date1 = moment( new Date( date ), "D/MM/YY" ).format("DD MMM Y");
    return date1;
  };

  const handleValidTime = (time) => {
    const time1 = new Date(time);
    const getHour = time1.getUTCHours();
    const getMin = time1.getUTCMinutes();
    const getTime = `${getHour}:${getMin}`;
    var meridiem = "";
    if (getHour >= 12) {
      meridiem = "PM";
    } else {
      meridiem = "AM";
    }
    const updateTime =
      moment(getTime, "hh:mm").format("hh:mm") + " " + meridiem;
    return updateTime;
  };

  // Checked All
  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".chauffeurCheckBox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  // SideBar Chauffeur Deatail

  document.title = props.t("Chauffeurs | Takci");

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={props.t("Chauffeurs")} pageTitle="Takci" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <div className="d-flex justify-content-end">
                    <div className="flex-shrink-0">
                      <button
                        className="btn add-btn"
                        style={{ background: "#002437", color: "white" }}
                        onClick={() => {
                          // setModal(true);
                          history.push("/chauffeur/add");
                        }}
                      >
                        <i className="ri-user-add-line me-1 align-bottom"></i>
                        {props.t("Ajouter Chauffeur")}
                      </button>{" "}
                      {chauffeurs.length > 0 && (
                        <button
                          disabled={chauffeurs.length <= 0}
                          type="button"
                          className="btn"
                          style={{ color: "#eac22f" }}
                          onClick={() => setIsExportCSV(true)}
                        >
                          <i className="ri-file-download-line align-bottom me-1"></i>{" "}
                          {props.t("Export")}
                        </button>
                      )}
                    </div>
                  </div>
                </CardHeader>
              </Card>
            </Col>
            <Col xxl={12}>
              <Card id="chauffeurList">
                <CardBody className="pt-0">
                  <div>
                    {loading ? (
                      <div className="text-center my-5">
                        <Loader style={{ color: "#014c94" }} />
                        <h2>Chargement...</h2>
                      </div>
                    ) : (
                      <>
                        <ExportCSVModal
                          show={isExportCSV}
                          onCloseClick={() => setIsExportCSV(false)}
                          data={chauffeurs.length > 0 ? chauffeurs : []}
                        />

                        {chauffeurs.length > 0 ? (
                          <TableContainer
                            columns={columns}
                            data={chauffeurs || []}
                            isGlobalFilter={true}
                            isAddUserList={false}
                            customPageSize={8}
                            isStatusFilter={[
                              "Tous",
                              "Activer",
                              "Desactiver",
                            ].map((status) => ({
                              label: status,
                              value: status,
                            }))}
                            className="custom-header-css"
                            divClass="table-responsive table-card mb-3"
                            tableClass="align-middle table-nowrap"
                            theadClass="table-light"
                            handleChauffeurClick={handleChauffeurClicks}
                          />
                        ) : (
                          <Card>
                            <CardBody className="p-4 border-top border-top-dashed">
                              <h6 className="text-muted text-uppercase fw-semibold mb-4">
                                Aucune donnée disponible
                              </h6>
                            </CardBody>
                          </Card>
                        )}
                      </>
                    )}
                  </div>

                  <Modal
                    id="showModal"
                    style={{ maxWidth: 800 }}
                    isOpen={modal}
                    centered
                  >
                    <ModalHeader className="bg-soft-info p-3">
                      {/* { isEdit === true ? props.t( "Modifier Chauffeur" ) : props.t( "Ajouter Chauffeur" ) } */}
                      {isEdit
                        ? props.t("Modifier Chauffeur")
                        : isEditPhone
                        ? props.t("Modifier le numero")
                        : props.t("Ajouter Chauffeur")}
                    </ModalHeader>

                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <ModalBody>
                        <Input type="hidden" id="id-field" />

                        {/*! Infos personnelles */}
                        <Row className="g-3">
                          {!isEditPhone && (
                            <>
                              <Col lg={4}>
                                <div>
                                  <Label
                                    htmlFor="last_name"
                                    className="form-label"
                                  >
                                    {props.t("Last Name")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Label>
                                  <Input
                                    name="last_name"
                                    id="last_name"
                                    className="form-control"
                                    placeholder={props.t("Entrez le nom")}
                                    type="text"
                                    validate={{
                                      required: { value: true },
                                    }}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.last_name || ""}
                                    invalid={
                                      validation.touched.last_name &&
                                      validation.errors.last_name
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.last_name &&
                                  validation.errors.last_name ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.last_name}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                              <Col lg={4}>
                                <div>
                                  <Label
                                    htmlFor="first_name"
                                    className="form-label"
                                  >
                                    {props.t("First Name")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Label>
                                  <Input
                                    name="first_name"
                                    id="first_name"
                                    className="form-control"
                                    placeholder={props.t("Entrez les prénoms")}
                                    type="text"
                                    validate={{
                                      required: { value: true },
                                    }}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.first_name || ""}
                                    invalid={
                                      validation.touched.first_name &&
                                      validation.errors.first_name
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.first_name &&
                                  validation.errors.first_name ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.first_name}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                              <Col lg={4}>
                                <div>
                                  <Label htmlFor="ville" className="form-label">
                                    {props.t("Ville de résidence")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Label>
                                  <Input
                                    name="ville"
                                    id="ville"
                                    className="form-control"
                                    placeholder={props.t("Entrez la ville")}
                                    type="text"
                                    validate={{
                                      required: { value: true },
                                    }}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.ville || ""}
                                    invalid={
                                      validation.touched.ville &&
                                      validation.errors.ville
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.ville &&
                                  validation.errors.ville ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.ville}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                              <Col lg={4}>
                                <div>
                                  <Label htmlFor="email" className="form-label">
                                    {props.t("Email")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Label>
                                  <Input
                                    name="email"
                                    id="email"
                                    className="form-control"
                                    placeholder={props.t("Entrez l'email")}
                                    type="email"
                                    validate={{
                                      required: { value: true },
                                    }}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.email || ""}
                                    invalid={
                                      validation.touched.email &&
                                      validation.errors.email
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.email &&
                                  validation.errors.email ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.email}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                            </>
                          )}

                          {(isEditPhone || !isEdit) && (
                            <>
                              <Col lg={4}>
                                <div>
                                  <Label
                                    htmlFor="telephone"
                                    className="form-label"
                                  >
                                    {props.t("Numéro de téléphone")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Label>
                                  <Input
                                    name="telephone"
                                    id="telephone"
                                    className="form-control"
                                    placeholder={props.t(
                                      "Entrez le numéro de téléphone"
                                    )}
                                    type="text"
                                    validate={{
                                      required: { value: true },
                                    }}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.telephone || ""}
                                    invalid={
                                      validation.touched.telephone &&
                                      validation.errors.telephone
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.telephone &&
                                  validation.errors.telephone ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.telephone}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                            </>
                          )}

                          {!isEdit && !isEditPhone && (
                            <>
                              <Col lg={4}>
                                <div>
                                  <Label
                                    htmlFor="type_conducteur"
                                    className="form-label"
                                  >
                                    {props.t("Type conducteur")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Label>
                                  <Input
                                    name="type_conducteur"
                                    id="type_conducteur"
                                    className="form-control"
                                    readOnly
                                    placeholder={props.t(
                                      "Entrez le type conducteur"
                                    )}
                                    type="text"
                                    validate={{
                                      required: { value: true },
                                    }}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={
                                      validation.values.type_conducteur ||
                                      "Conducteur"
                                    }
                                    invalid={
                                      validation.touched.type_conducteur &&
                                      validation.errors.type_conducteur
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.type_conducteur &&
                                  validation.errors.type_conducteur ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.type_conducteur}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                              <Col lg={4}>
                                <div>
                                  <Label
                                    htmlFor="code_parrain"
                                    className="form-label"
                                  >
                                    {props.t("Code de parainnage")}
                                  </Label>
                                  <Input
                                    name="code_parrain"
                                    id="code_parrain"
                                    className="form-control"
                                    placeholder={props.t(
                                      "Entrez le code de parainnage"
                                    )}
                                    type="text"
                                    validate={{
                                      required: { value: true },
                                    }}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.code_parrain || ""}
                                    invalid={
                                      validation.touched.code_parrain &&
                                      validation.errors.code_parrain
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.code_parrain &&
                                  validation.errors.code_parrain ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.code_parrain}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                              <Col lg={4}>
                                <div>
                                  <Label
                                    htmlFor="password"
                                    className="form-label"
                                  >
                                    {props.t("Mot de passe")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Label>
                                  <Input
                                    name="password"
                                    id="password"
                                    className="form-control"
                                    placeholder={props.t(
                                      "Entrez le mot de passe"
                                    )}
                                    type="text"
                                    validate={{
                                      required: { value: true },
                                    }}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.password || ""}
                                    invalid={
                                      validation.touched.password &&
                                      validation.errors.password
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.password &&
                                  validation.errors.password ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.password}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                            </>
                          )}
                        </Row>
                        {/*! Infos personnelles */}

                        <hr />

                        {/* Documents */}
                        <Row className="g-3">
                          <Col lg={4}>
                            <div>
                              <Label className="form-label" htmlFor="photo">
                                {props.t("Photo")}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </Label>
                              <Input
                                type="file"
                                accept="image/*"
                                className="form"
                                id="photo"
                                name="photo"
                                onBlur={validation.handleBlur}
                                onChange={(e) => {
                                  validation.handleChange(e);
                                  handlePhoto(e);
                                }}
                                invalid={
                                  validation.errors.photo &&
                                  validation.touched.photo
                                    ? true
                                    : false
                                }
                              />
                              {validation.errors.photo &&
                              validation.touched.photo ? (
                                <FormFeedback type="invalid">
                                  {props.t(validation.errors.photo)}
                                </FormFeedback>
                              ) : null}
                              {file4 && (
                                <>
                                  <br />
                                  <center>
                                    <img src={file4} width="50px" alt="Photo" />
                                  </center>
                                </>
                              )}
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div>
                              <Label
                                className="form-label"
                                htmlFor="photo_engin"
                              >
                                {props.t("Photo de l'engin")}
                                <span style={{ color: "red" }}>*</span>
                              </Label>
                              <Input
                                type="file"
                                accept="image/*"
                                className="form"
                                id="photo_engin"
                                name="photo_engin"
                                onBlur={validation.handleBlur}
                                onChange={(e) => {
                                  validation.handleChange(e);
                                  handleEngin(e);
                                }}
                                invalid={
                                  validation.errors.photo_engin &&
                                  validation.touched.photo_engin
                                    ? true
                                    : false
                                }
                              />
                              {validation.errors.photo_engin &&
                              validation.touched.photo_engin ? (
                                <FormFeedback type="invalid">
                                  {props.t(validation.errors.photo_engin)}
                                </FormFeedback>
                              ) : null}
                              {file7 && (
                                <>
                                  <br />
                                  <center>
                                    <img
                                      src={file7}
                                      width="50px"
                                      alt="Photo de l'engin"
                                    />
                                  </center>
                                </>
                              )}
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div>
                              <Label
                                className="form-label"
                                htmlFor="visite_technique"
                              >
                                {props.t("Visite technique")}
                                <span style={{ color: "red" }}>*</span>
                              </Label>
                              <Input
                                type="file"
                                accept="image/*"
                                className="form"
                                id="visite_technique"
                                name="visite_technique"
                                onBlur={validation.handleBlur}
                                onChange={(e) => {
                                  validation.handleChange(e);
                                  handleVisite(e);
                                }}
                                invalid={
                                  validation.errors.visite_technique &&
                                  validation.touched.visite_technique
                                    ? true
                                    : false
                                }
                              />
                              {validation.errors.visite_technique &&
                              validation.touched.visite_technique ? (
                                <FormFeedback type="invalid">
                                  {props.t(validation.errors.visite_technique)}
                                </FormFeedback>
                              ) : null}
                              {file6 && (
                                <>
                                  <br />
                                  <center>
                                    <img
                                      src={file6}
                                      width="50px"
                                      alt="Visite technique"
                                    />
                                  </center>
                                </>
                              )}
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div>
                              <Label
                                className="form-label"
                                htmlFor="attestation_residence"
                              >
                                {props.t("Attestation de résidence")}
                                <span style={{ color: "red" }}>*</span>
                              </Label>
                              <Input
                                type="file"
                                accept="image/*"
                                className="form"
                                id="attestation_residence"
                                name="attestation_residence"
                                onBlur={validation.handleBlur}
                                onChange={(e) => {
                                  validation.handleChange(e);
                                  handleAttestation(e);
                                }}
                                invalid={
                                  validation.errors.attestation_residence &&
                                  validation.touched.attestation_residence
                                    ? true
                                    : false
                                }
                              />
                              {validation.errors.attestation_residence &&
                              validation.touched.attestation_residence ? (
                                <FormFeedback type="invalid">
                                  {props.t(
                                    validation.errors.attestation_residence
                                  )}
                                </FormFeedback>
                              ) : null}

                              {file2 && (
                                <>
                                  <br />
                                  <center>
                                    <img
                                      src={file2}
                                      width="50px"
                                      alt="Attestation de résidence"
                                    />
                                  </center>
                                </>
                              )}
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div>
                              <Label
                                className="form-label"
                                htmlFor="carte_grise"
                              >
                                {props.t("Carte grise")}
                                <span style={{ color: "red" }}>*</span>
                              </Label>
                              <Input
                                type="file"
                                accept="image/*"
                                className="form"
                                id="carte_grise"
                                name="carte_grise"
                                onBlur={validation.handleBlur}
                                onChange={(e) => {
                                  validation.handleChange(e);
                                  handleCarteGrise(e);
                                }}
                                invalid={
                                  validation.errors.carte_grise &&
                                  validation.touched.carte_grise
                                    ? true
                                    : false
                                }
                              />
                              {validation.errors.carte_grise &&
                              validation.touched.carte_grise ? (
                                <FormFeedback type="invalid">
                                  {props.t(validation.errors.carte_grise)}
                                </FormFeedback>
                              ) : null}

                              {file9 && (
                                <>
                                  <br />
                                  <center>
                                    <img
                                      src={file9}
                                      width="50px"
                                      alt="Carte grise"
                                    />
                                  </center>
                                </>
                              )}
                            </div>
                          </Col>

                          <Col lg={4}>
                            <Label
                              className="form-label"
                              htmlFor="piece_identite"
                            >
                              {props.t("Pièce d'identite")}
                              <span style={{ color: "red" }}>*</span>
                            </Label>

                            <InputGroup>
                              <Input
                                type="file"
                                accept="image/*"
                                className="form"
                                id="piece_identite"
                                name="piece_identite"
                                onBlur={validation.handleBlur}
                                onChange={(e) => {
                                  validation.handleChange(e);
                                  handlePiece(e);
                                }}
                                invalid={
                                  validation.errors.piece_identite &&
                                  validation.touched.piece_identite
                                    ? true
                                    : false
                                }
                              />

                              <Link
                                to="#"
                                className="btn"
                                outline
                                style={{ color: "#014c94" }}
                                id="date_expir_identite_tooltip"
                              >
                                <i className="ri-calendar-2-fill"></i>
                              </Link>
                              <div className="text-center">
                                <UncontrolledTooltip
                                  placement="top"
                                  target="date_expir_identite_tooltip"
                                  trigger="click"
                                >
                                  <DatePicker
                                    name="date_expir_identite"
                                    id="date_expir_identite"
                                    onChange={(value) =>
                                      setdate_expir_identite(value)
                                    }
                                    selected={date_expir_identite}
                                    minDate={new Date()} // Empêche la sélection de dates passées
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="Sélectionnez une date"
                                    className="form-control m-0"
                                    required
                                  />
                                </UncontrolledTooltip>
                              </div>
                            </InputGroup>

                            <div>
                              {validation.errors.piece_identite &&
                              validation.touched.piece_identite ? (
                                <FormFeedback type="invalid">
                                  {props.t(validation.errors.piece_identite)}
                                </FormFeedback>
                              ) : null}

                              {file1 && (
                                <>
                                  <br />
                                  <center>
                                    <img
                                      src={file1}
                                      width="50px"
                                      alt="Pièce d'identite"
                                    />
                                  </center>
                                </>
                              )}
                            </div>
                          </Col>
                          <Col lg={4}>
                            <Label className="form-label" htmlFor="permis">
                              {props.t("Permis")}
                              <span style={{ color: "red" }}>*</span>
                            </Label>

                            <InputGroup>
                              <Input
                                type="file"
                                accept="image/*"
                                className="form"
                                id="permis"
                                name="permis"
                                onBlur={validation.handleBlur}
                                onChange={(e) => {
                                  validation.handleChange(e);
                                  handlePermis(e);
                                }}
                                invalid={
                                  validation.errors.permis &&
                                  validation.touched.permis
                                    ? true
                                    : false
                                }
                              />

                              <Link
                                to="#"
                                className="btn"
                                outline
                                style={{ color: "#014c94" }}
                                id="date_expir_permis_tooltip"
                              >
                                <i className="ri-calendar-2-fill"></i>
                              </Link>
                              <div className="text-center">
                                <UncontrolledTooltip
                                  placement="top"
                                  target="date_expir_permis_tooltip"
                                  trigger="click"
                                >
                                  <DatePicker
                                    name="date_expir_permis"
                                    id="date_expir_permis"
                                    onChange={(value) =>
                                      setdate_expir_permis(value)
                                    }
                                    selected={date_expir_permis}
                                    minDate={new Date()} // Empêche la sélection de dates passées
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="Sélectionnez une date"
                                    className="form-control m-0"
                                    required
                                  />
                                </UncontrolledTooltip>
                              </div>
                            </InputGroup>

                            <div>
                              {validation.errors.permis &&
                              validation.touched.permis ? (
                                <FormFeedback type="invalid">
                                  {props.t(validation.errors.permis)}
                                </FormFeedback>
                              ) : null}

                              {file3 && (
                                <>
                                  <br />
                                  <center>
                                    <img
                                      src={file3}
                                      width="50px"
                                      alt="Permis"
                                    />
                                  </center>
                                </>
                              )}
                            </div>
                          </Col>
                          <Col lg={4}>
                            <Label className="form-label" htmlFor="assurance">
                              {props.t("Assurance")}
                              <span style={{ color: "red" }}>*</span>
                            </Label>

                            <InputGroup>
                              <Input
                                type="file"
                                accept="image/*"
                                className="form"
                                id="assurance"
                                name="assurance"
                                onBlur={validation.handleBlur}
                                onChange={(e) => {
                                  validation.handleChange(e);
                                  handleAssurance(e);
                                }}
                                invalid={
                                  validation.errors.assurance &&
                                  validation.touched.assurance
                                    ? true
                                    : false
                                }
                              />

                              <Link
                                to="#"
                                className="btn"
                                outline
                                style={{ color: "#014c94" }}
                                id="date_expir_assurance_tooltip"
                              >
                                <i className="ri-calendar-2-fill"></i>
                              </Link>
                              <div className="text-center">
                                <UncontrolledTooltip
                                  placement="top"
                                  target="date_expir_assurance_tooltip"
                                  trigger="click"
                                >
                                  <DatePicker
                                    name="date_expir_assurance"
                                    id="date_expir_assurance"
                                    onChange={(value) =>
                                      setdate_expir_assurance(value)
                                    }
                                    selected={date_expir_assurance}
                                    minDate={new Date()} // Empêche la sélection de dates passées
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="Sélectionnez une date"
                                    className="form-control m-0"
                                    required
                                  />
                                </UncontrolledTooltip>
                              </div>
                            </InputGroup>

                            <div>
                              {validation.errors.assurance &&
                              validation.touched.assurance ? (
                                <FormFeedback type="invalid">
                                  {props.t(validation.errors.assurance)}
                                </FormFeedback>
                              ) : null}

                              {file5 && (
                                <>
                                  <br />
                                  <center>
                                    <img
                                      src={file5}
                                      width="50px"
                                      alt="Assurance"
                                    />
                                  </center>
                                </>
                              )}
                            </div>
                          </Col>

                          <Col lg={4}>
                            <Label className="form-label" htmlFor="droit_taxi">
                              {props.t("Droit Taxi")}
                              <span style={{ color: "red" }}>*</span>
                            </Label>

                            <InputGroup>
                              <Input
                                type="file"
                                accept="image/*"
                                className="form"
                                id="droit_taxi"
                                name="droit_taxi"
                                onBlur={validation.handleBlur}
                                onChange={(e) => {
                                  validation.handleChange(e);
                                  handleDroitTaxi(e);
                                }}
                                invalid={
                                  validation.errors.droit_taxi &&
                                  validation.touched.droit_taxi
                                    ? true
                                    : false
                                }
                              />

                              <Link
                                to="#"
                                className="btn"
                                outline
                                style={{ color: "#014c94" }}
                                id="date_expir_droit_taxi_tooltip"
                              >
                                <i className="ri-calendar-2-fill"></i>
                              </Link>
                              <div className="text-center">
                                <UncontrolledTooltip
                                  placement="top"
                                  target="date_expir_droit_taxi_tooltip"
                                  trigger="click"
                                >
                                  <DatePicker
                                    name="date_expir_droit_taxi"
                                    id="date_expir_droit_taxi"
                                    onChange={(value) =>
                                      setdate_expir_droit_taxi(value)
                                    }
                                    selected={date_expir_droit_taxi}
                                    minDate={new Date()} // Empêche la sélection de dates passées
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="Sélectionnez une date"
                                    className="form-control m-0"
                                    required
                                  />
                                </UncontrolledTooltip>
                              </div>
                            </InputGroup>

                            <div>
                              {validation.errors.droit_taxi &&
                              validation.touched.droit_taxi ? (
                                <FormFeedback type="invalid">
                                  {props.t(validation.errors.droit_taxi)}
                                </FormFeedback>
                              ) : null}

                              {file8 && (
                                <>
                                  <br />
                                  <center>
                                    <img
                                      src={file8}
                                      width="50px"
                                      alt="Droit taxi"
                                    />
                                  </center>
                                </>
                              )}
                            </div>
                          </Col>
                        </Row>
                        {/*! Documents */}
                      </ModalBody>
                      <ModalFooter>
                        <div className="hstack gap-2 justify-content-end">
                          <Button
                            type="button"
                            onClick={() => {
                              setModal(false);
                              fetchDataDetail();
                            }}
                            className="btn-light"
                          >
                            {props.t("Fermer")}
                          </Button>

                          {/* <button type="button" className="btn btn-light" onClick={() => { setModal(false);dispatch(onGetChauffeurs); }} > {props.t("Fermer")} </button> */}
                          <Button
                            type="submit"
                            className="btn"
                            style={{ background: "#002437", color: "white" }}
                            id="add-btn"
                          >
                            {isEdit
                              ? props.t("Edit")
                              : isEditPhone
                              ? props.t("Edit")
                              : props.t("Ajouter Chauffeur")}
                          </Button>
                        </div>
                      </ModalFooter>
                    </Form>
                  </Modal>

                  <Modal
                    id="showModalMotif"
                    style={{ maxWidth: 800 }}
                    isOpen={modalMotif}
                    centered
                  >
                    <ModalHeader className="bg-soft-info p-3">
                      {props.t("Motif de la désativation")}
                    </ModalHeader>

                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validationRefuse.handleSubmit();
                        return false;
                      }}
                    >
                      <ModalBody>
                        <Input type="hidden" id="id-field" />
                        <Row className="g-3">
                          <Col lg={12}>
                            <div>
                              <Label
                                htmlFor="motif_refuse"
                                className="form-label"
                              >
                                {props.t("Motif")}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </Label>
                              <Input
                                name="motif_refuse"
                                id="motif_refuse"
                                className="form-control"
                                placeholder={props.t("Entrez le motif")}
                                type="textarea"
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validationRefuse.handleChange}
                                onBlur={validationRefuse.handleBlur}
                                value={
                                  validationRefuse.values.motif_refuse || ""
                                }
                                invalid={
                                  validationRefuse.touched.motif_refuse &&
                                  validationRefuse.errors.motif_refuse
                                    ? true
                                    : false
                                }
                              />
                              {validationRefuse.touched.motif_refuse &&
                              validationRefuse.errors.motif_refuse ? (
                                <FormFeedback type="invalid">
                                  {validationRefuse.errors.motif_refuse}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                        </Row>
                      </ModalBody>
                      <ModalFooter>
                        <div className="hstack gap-2 justify-content-end">
                          <Button
                            type="button"
                            onClick={() => {
                              setModalMotif(false);
                              fetchDataDetail();
                            }}
                            className="btn-light"
                          >
                            {props.t("Fermer")}
                          </Button>
                          {/* <button type="button" className="btn btn-light" onClick={() => { setModal(false);dispatch(onGetChauffeurs); }} > {props.t("Fermer")} </button> */}
                          <Button
                            type="submit"
                            className="btn btn-primary"
                            id="add-motif-btn"
                            style={{ background: "#002437", color: "white" }}
                          >
                            Envoyer la Motif
                          </Button>
                        </div>
                      </ModalFooter>
                    </Form>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ToastContainer closeButton={false} />
        </Container>
      </div>
    </React.Fragment>
  );
};

ChauffeurEnAttente.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(ChauffeurEnAttente));
